/* eslint-disable-next-line import/prefer-default-export */
export const INVITE_STUDENTS_LINK_ID = 'invite-students-link';
